import React, { useState, useEffect } from 'react';
import { THEME } from '../../utils/theme';
import api from '../../utils/api';
import Spinner from '../ui/Spinner';

const YearReviewModal = ({ onClose, year }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/api/stats/year-review/${year}`).then(d => {
      setData(d);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [year]);

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(5,5,10,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, backdropFilter: 'blur(20px) saturate(180%)', WebkitBackdropFilter: 'blur(20px) saturate(180%)' }} onClick={onClose}>
      <div style={{ background: `linear-gradient(145deg, ${THEME.bgElevated}, ${THEME.bgCard})`, borderRadius: '20px', padding: '24px', width: '95%', maxWidth: '500px', maxHeight: '85vh', overflow: 'auto', border: `1px solid ${THEME.border}`, boxShadow: `0 25px 80px ${THEME.shadowHeavy}`, animation: 'scaleIn 0.2s ease' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ margin: 0, color: THEME.text, fontSize: '20px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ fontSize: '24px' }}>📅</span> {year} in Review
          </h2>
          <button onClick={onClose} style={{ background: THEME.bgHover, border: 'none', borderRadius: '8px', padding: '8px 12px', color: THEME.textMuted, cursor: 'pointer' }}>✕</button>
        </div>

        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}><Spinner /></div>
        ) : !data ? (
          <div style={{ textAlign: 'center', color: THEME.textMuted, padding: '40px' }}>No data for {year}</div>
        ) : (
          <div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '12px', marginBottom: '20px' }}>
              <div style={{ background: THEME.bg, borderRadius: '12px', padding: '16px', textAlign: 'center' }}>
                <div style={{ fontSize: '28px', fontWeight: '700', color: THEME.accent }}>{data.total_hours}</div>
                <div style={{ color: THEME.textMuted, fontSize: '12px' }}>Hours Played</div>
              </div>
              <div style={{ background: THEME.bg, borderRadius: '12px', padding: '16px', textAlign: 'center' }}>
                <div style={{ fontSize: '28px', fontWeight: '700', color: THEME.info }}>{data.unique_games_played}</div>
                <div style={{ color: THEME.textMuted, fontSize: '12px' }}>Games Played</div>
              </div>
              <div style={{ background: THEME.bg, borderRadius: '12px', padding: '16px', textAlign: 'center' }}>
                <div style={{ fontSize: '28px', fontWeight: '700', color: THEME.success }}>{data.total_sessions}</div>
                <div style={{ color: THEME.textMuted, fontSize: '12px' }}>Sessions</div>
              </div>
              <div style={{ background: THEME.bg, borderRadius: '12px', padding: '16px', textAlign: 'center' }}>
                <div style={{ fontSize: '28px', fontWeight: '700', color: THEME.warning }}>{data.total_ratings ?? ((data.omega_ratings_given || 0) + (data.supe_ratings_given || 0))}</div>
                <div style={{ color: THEME.textMuted, fontSize: '12px' }}>Ratings Given</div>
              </div>
            </div>

            {data.most_active_month && (
              <div style={{ background: `linear-gradient(135deg, ${THEME.omega}20, ${THEME.supe}20)`, borderRadius: '12px', padding: '14px', marginBottom: '20px', textAlign: 'center' }}>
                <div style={{ color: THEME.textMuted, fontSize: '12px' }}>Most Active Month</div>
                <div style={{ color: THEME.text, fontSize: '18px', fontWeight: '700' }}>{data.most_active_month}</div>
                <div style={{ color: THEME.textSecondary, fontSize: '11px' }}>{data.most_active_month_sessions} sessions</div>
              </div>
            )}

            {data.top_games && data.top_games.length > 0 && (
              <div>
                <h3 style={{ color: THEME.text, fontSize: '14px', fontWeight: '600', marginBottom: '12px' }}>Top Games of {year}</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {data.top_games.map((game, idx) => (
                    <div key={game.id} style={{ display: 'flex', gap: '10px', alignItems: 'center', padding: '10px', background: THEME.bg, borderRadius: '10px' }}>
                      <div style={{ width: '24px', height: '24px', background: idx === 0 ? '#fbbf24' : THEME.bgElevated, borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700', color: idx === 0 ? '#000' : THEME.textMuted, fontSize: '12px' }}>{idx + 1}</div>
                      <img src={game.header_image} alt="" style={{ width: '50px', height: '28px', objectFit: 'cover', borderRadius: '4px' }} />
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ color: THEME.text, fontSize: '13px', fontWeight: '500', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{game.name}</div>
                      </div>
                      <div style={{ color: THEME.accent, fontWeight: '600', fontSize: '13px' }}>{game.hours}h</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default YearReviewModal;
